import { component as defineComponent } from 'flightjs';

function OffsetGlobalNav() {
    this.attributes({
        'ocWrapper': '[data-globalnavui]',
        'offsetDataAttr': 'data-oc-offset-admin-bar'
    });

    this.after('initialize', function() {
        this.on(document, 'brandContainer.ui.adminBarShown', this.applyOffset);
        this.on(document, 'brandContainer.ui.adminBarHidden', this.removeOffset);
    });

    this.applyOffset = function() {
        this.select('ocWrapper').attr(this.attr.offsetDataAttr, true);
    };

    this.removeOffset = function() {
        this.select('ocWrapper').removeAttr(this.attr.offsetDataAttr);
    }
};

export default defineComponent(OffsetGlobalNav);



// WEBPACK FOOTER //
// ./~/@99designs/brand-container/lib/ui/offset-global-nav.js